<script>
	import PageSection from "../../components/PageSection.svelte";
	import PersonalDetails from "./PersonalDetails.svelte";
	import Details from "./Details.svelte";
	import Checkbox from "../../components/Checkbox.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";

	export let title = null;
	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let nextPageLabel = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	let disabled = true;

	if ($pageNumber == pageIndex + 1) {
		alert("Your registration has already been submitted.");
		window.location.href = window.basePath;
	} else {
		$pageNumber = pageIndex;
		document.title = pageTitle || `${projectSettings.classActionName} - Confirmation`;
	}

	$model.LastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	let confirmed = false;
</script>

{#if $pageNumber == pageIndex}
	<PageSection>
		<h1>Confirmation</h1>
		<p>Please check the below details are correct before submitting your registration.</p>
		<form>
			<div class="print-page-list">
				<div class="print-page">
					<PersonalDetails {disabled}></PersonalDetails>
				</div>
				<div class="print-page">
					<Details {disabled}></Details>
				</div>
				<div class="form-group form-row">
					<div class="col-md-12">
						<Checkbox
							id="tac"
							required="true"
							bind:checked={confirmed}
							label="I confirm that all information provided in this section is true and correct."
						></Checkbox>
					</div>
				</div>
			</div>

			<div class="form-row">
				<div class="col-md-12 last">
					<NavigationButtons
						{persistUrl}
						{previousPage}
						{nextPage}
						{nextPageLabel}
						tealiumTag={true}
						pageName={title}
					></NavigationButtons>
				</div>
			</div>
		</form>
	</PageSection>
{/if}

<style>
	.print-page-list .print-page {
		margin-top: 50px;
	}

	.print-page-list .print-page:first-child {
		margin-top: 0;
	}
</style>
